const state = {
  poi: {
    'wpp': {
      title: 'ZONA WPP',
      enable: 'AKTIF',
      aktif: {},
      allowed: {}
    },
    'port': {
      title: 'ZONA PELABUHAN',
      enable: 'AKTIF'
    },
    'kapal': {
      title: 'LIST KAPAL',
      enable: 'AKTIF'
    },
    'zone': {
      title: 'ZONA Tambahan',
      enable: 'AKTIF'
    }
  },
  basemap: [],
  layers: {},
  listWPP: [],
  listZone: {}
}

const getters = {
  poi: (state) => state.poi,
  basemap: (state) => state.basemap,
  layers: (state) => state.layers,
  listWPP: (state) => state.listWPP,
  listZone: (state) => state.listZone
}

const actions = {
  toLoadPoi: async ({ state, commit, dispatch }) => {
    commit('setLoading', 'memuat pengaturan')

    const userConfig = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/user-config`
    })

    if (userConfig) {
      const poi = {}

      for (var configKey in userConfig.data.config) {
        if (state.poi[configKey]) {
          window.localStorage.setItem(`poi_${configKey}`, userConfig.data.config[configKey])

          poi[configKey] = state.poi[configKey]
          poi[configKey].enable = userConfig.data.config[configKey]
        }
      }

      window.localStorage.setItem('poi_filter', userConfig.data.config.filter)
      window.localStorage.setItem('poi_layer', userConfig.data.config.layer)

      let wpp = {}

      try {
        wpp = JSON.parse(userConfig.data.config.wpp_show)
      } catch (err) {
        wpp = {}
      }

      window.localStorage.setItem('poi_wpp_show', userConfig.data.config.wpp_show)
      window.localStorage.setItem('poi_wpp_allowed', userConfig.data.config.wpp_allowed)
      window.localStorage.setItem('poi_zone_show', userConfig.data.config.zone_show)
      window.localStorage.setItem('poi_layers_show', userConfig.data.config.layer_show)

      commit('setPoi', poi)
      commit('setListWPP', wpp)
    }
  },
  toApplyPoi: async ({ commit, dispatch }) => {
    const currentPoi = {}

    for (var poiKey in state.poi) {
      if (state.poi[poiKey]) {
        let enable = window.localStorage.getItem(`poi_${poiKey}`)

        if (enable === 'AKTIF') {
          await dispatch(`toApplyPoi$${poiKey}`)
        }

        currentPoi[poiKey] = state.poi[poiKey]
        currentPoi[poiKey].enable = enable
      }
    }

    commit('setPoi', currentPoi)
  },
  toApplyPoi$wpp: async ({ rootState, commit, dispatch }) => {
    if (rootState.geo.geoWPP === null) {
      await dispatch('toLoadGeoWPP')

      try {
        const wppShow = JSON.parse(window.localStorage.getItem('poi_wpp_show'))

        if (wppShow !== null) {
          commit('setPoiAktif', {
            name: 'wpp',
            aktif: wppShow
          })
        }

        const wppAllowed = JSON.parse(window.localStorage.getItem('poi_wpp_allowed'))

        if (wppShow !== null) {
          const wppAllowedIds = {}

          for (var wppAllowedIndex in wppAllowed) {
            wppAllowedIds[wppAllowed[wppAllowedIndex]] = true
          }

          commit('setPoiAllowed', {
            name: 'wpp',
            allowed: wppAllowed
          })
        }
      } catch (err) {
        // something error with wpp config
      }
    }

    await dispatch('toDrawWPP')
  },
  toUnApplyPoi$wpp: ({ dispatch }) => {
    dispatch('toRemoveWPP')
  },
  toApplyPoi$port: async ({ rootState, dispatch }) => {
    if (rootState.geo.geoPortzone === null) {
      await dispatch('toLoadGeoPorts')
      await dispatch('toLoadSettingPorts', {
        role_id: rootState.auth.auth.role_id,
        with_default: false
      })
    }

    await dispatch('toDrawPorts')
  },
  toUnApplyPoi$port: ({ dispatch }) => {
    dispatch('toRemovePorts')
    dispatch('toRedraw')
  },
  toApplyPoi$kapal: async ({ dispatch }) => {
    await dispatch('toDrawListKapal', {
      offset: 0,
      limit: 999999
    })
  },
  toUnApplyPoi$kapal: ({ dispatch }) => {
    dispatch('toRedraw')
  },
  toApplyPoi$zone: async ({ dispatch }) => {
    try {
      const poiZoneShow = JSON.parse(window.localStorage.getItem('poi_zone_show'))

      for (let zoneId in poiZoneShow) {
        const zone = await dispatch('authenticatedApi', {
          method: 'get',
          url: `${window.config.BASEURL_API1}/zone/${zoneId}`
        })

        if (zone) {
          zone.data.zone.enable = poiZoneShow[zoneId]

          await dispatch('toLoadZone', zone.data.zone)
        }
      }
    } catch (err) {
      // something error with zone config
    }

    dispatch('toDrawZones')
  },
  toUnApplyPoi$zone: ({ dispatch }) => {
    dispatch('toRemoveZones')
  },
  togglePoi: async ({ state, commit, dispatch }, poi) => {
    commit('setLoading', 'memperbaharui pengaturan')

    const data = {}

    data[poi.key] = poi.enable

    await dispatch('authenticatedApi', {
      method: 'put',
      url: `${window.config.BASEURL_API1}/user-config`,
      data
    })

    const selectedPoi = {}

    selectedPoi[poi.key] = state.poi[poi.key]
    selectedPoi[poi.key].enable = poi.enable

    window.localStorage.setItem(`poi_${poi.key}`, poi.enable)
    commit('setPoi', selectedPoi)

    if (poi.enable === 'AKTIF') {
      await dispatch(`toApplyPoi$${poi.key}`)
    } else {
      await dispatch(`toUnApplyPoi$${poi.key}`)
    }

    commit('unsetLoading')
  },
  toLoadBasemap: async ({ commit, dispatch }) => {
    commit('setLoading', 'memuat data basemap')

    const basemap = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/basemap`
    })

    if (basemap) {
      commit('setBasemap', basemap.data.basemap)
    }

    commit('unsetLoading')
  },
  toLoadLayers: async ({ commit, dispatch }) => {
    commit('setLoading', 'memuat data layer')

    const layers = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/layers`
    })

    if (layers) {
      try {
        const layerShow = JSON.parse(window.localStorage.getItem('poi_layers_show'))

        for (var layer of layers.data.layers) {
          const layerIdString = `${layer.id}`

          for (var layerId in layerShow) {
            if (layerId === layerIdString) {
              layer.enable = layerShow[layerId]
            }
          }
        }

        commit('setLayers', layers.data.layers)
      } catch (err) {
        // something error with layer config
      }
    }

    commit('unsetLoading')
  },
  toLoadListWPP: async ({ commit, dispatch }) => {
    commit('setLoading', 'memuat data layer')

    const listWPP = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/wpp`
    })

    if (listWPP) {
      commit('setListWPP', listWPP.data.wpp)
    }

    commit('unsetLoading')
  },
  toToggleLayer: async ({ state, commit, dispatch }, layerIndex) => {
    commit('setLoading', 'memuat data basemap')

    commit('setLayerEnable', {
      index: layerIndex,
      enable: !state.layers[layerIndex].enable
    })

    const aktif = {}

    for (var layer of state.layers) {
      if (layer.enable) {
        aktif[layer.id] = true
      }
    }

    const layerShow = JSON.stringify(aktif)

    window.localStorage.setItem('poi_layers_show', layerShow)

    await dispatch('authenticatedApi', {
      method: 'put',
      url: `${window.config.BASEURL_API1}/user-config`,
      data: {
        'layer_show': layerShow
      }
    })

    dispatch('toggleLayer', state.layers[layerIndex])

    commit('unsetLoading')
  },
  toToggleWPP: async ({ state, commit, dispatch }, wpp) => {
    commit('setLoading', 'memperbaharui pengaturan')

    const selectedWPP = state.listWPP[wpp.key]

    if (selectedWPP) {
      const aktif = state.poi.wpp.aktif

      if (!wpp.enable) {
        delete aktif[selectedWPP.wpp_id]
      } else {
        aktif[selectedWPP.wpp_id] = true
      }

      let aktifTotal = 0

      // eslint-disable-next-line
      for (var i in state.poi.wpp.aktif) {
        aktifTotal++
      }

      // add non wpp filter
      if (aktifTotal >= state.listWPP.length) {
        aktif['0'] = true
      } else {
        delete aktif['0']
      }

      commit('setPoiAktif', {
        name: 'wpp',
        aktif: aktif
      })

      const wppShow = JSON.stringify(aktif)

      window.localStorage.setItem('poi_wpp_show', wppShow)

      await dispatch('authenticatedApi', {
        method: 'put',
        url: `${window.config.BASEURL_API1}/user-config`,
        data: {
          'wpp_show': wppShow
        }
      })

      await dispatch('toDrawListKapal', {
        offset: 0,
        limit: 999999
      })
    }

    commit('unsetLoading')
  },
  toToggleZone: async ({ rootState, state, commit, dispatch }, zone) => {
    if (state.poi.zone.enable !== 'AKTIF') return

    const selectedZone = rootState.zones.zones.data[zone.index]

    if (selectedZone) {
      selectedZone.enable = zone.enable

      if (typeof state.listZone[selectedZone.id] === 'undefined') {
        await dispatch('toLoadZone', selectedZone)
      } else {
        commit('setZone', selectedZone)
      }

      commit('setLoading', 'memperbaharui pengaturan')

      let zoneShow = {}

      for (let zoneId in state.listZone) {
        zoneShow[zoneId] = state.listZone[zoneId].enable
      }

      zoneShow = JSON.stringify(zoneShow)

      window.localStorage.setItem('poi_zone_show', zoneShow)

      await dispatch('authenticatedApi', {
        method: 'put',
        url: `${window.config.BASEURL_API1}/user-config`,
        data: {
          'zone_show': zoneShow
        }
      })

      commit('unsetLoading')
    }

    dispatch('toDrawZones')
  },
  toLoadZone: async ({ commit, dispatch }, zone) => {
    commit('setLoading', 'memuat data zona')

    let zoneGeo = null

    if (zone.enable && typeof zone.geo === 'undefined') {
      const resultGeo = await dispatch('authenticatedApi', {
        method: 'get',
        url: `${window.config.BASEURL}/${zone.path}`
      })

      if (resultGeo) {
        zoneGeo = resultGeo.data
      }
    }

    zone.geo = zoneGeo

    commit('setZone', zone)
    commit('unsetLoading')
  }
}

const mutations = {
  setPoi: (state, poi) => state.poi = { ...state.poi, ...poi },
  setPoiAktif: (state, poi) => state.poi[poi.name].aktif = poi.aktif,
  setPoiAllowed: (state, poi) => state.poi[poi.name].allowed = poi.allowed,
  setBasemap: (state, basemap) => state.basemap = basemap,
  setLayers: (state, layers) => state.layers = layers,
  setListWPP: (state, listWPP) => state.listWPP = listWPP,
  setZone: (state, zone) => state.listZone[zone.id] = zone,
  setPoiEnable: (state, poi) => state.poi[poi.key].enable = poi.enable,
  setLayerEnable: (state, layer) => state.layers[layer.index].enable = layer.enable
}

export default {
  state,
  getters,
  actions,
  mutations
}
